import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalEventMangerService } from '../global-event-manger.service';
import { LocalstorageService } from '../localstorage.service';

@Component({
  selector: 'app-pagenotfound',
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.css']
})
export class PagenotfoundComponent implements OnInit {
  public currentToken = <any>{};
  public userDetails = <any>{};
  public userRole : string;
  public buttonType : string = '3';

  constructor(private globalEventMangerService: GlobalEventMangerService, private localStorageService: LocalstorageService, private router: Router) {
    this.globalEventMangerService.showNavBarEmitter.subscribe((mode)=>{
      if(mode) {
        this.globalEventMangerService.showNavBar(false);    
      }
    });
  }

  ngOnInit() { 
    this.currentToken = this.localStorageService.getData("currentUserToken");
    this.userDetails = this.localStorageService.getData("currentUser");
    this.userRole = this.userDetails && this.userDetails.role_id;
    if(this.userDetails && this.userRole == '3' && !this.currentToken.data.is_steps_completed) {
      this.buttonType = '1';
    } else if(this.userDetails) {
      this.buttonType = '2';
    } else {
      this.buttonType = '3';
    }
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/pagenotfound/pagenotfound.component.ts